import React, { useState } from "react";

import {
  Container,
  ButtonFilter,
  MoreFilters,
  ModalFilterItem,
  ModalFilterContainer,
  TextClearFilters,
  ConfirmButton,
  SelectContent,
} from "./styles";

//icons
import { IoMdArrowDropdown, IoIosAddCircleOutline } from "react-icons/io";
import { BsEraser } from "react-icons/bs";

//Custom components
// import ModalHeader from "../ModalHeader";
// import DateFilter from "../DateFilter";

//Utils
import Select from "react-select";
import Modal from "react-modal";

//MUI
import Menu from "@mui/material/Menu";
import { filtersHelper } from "@helpers/filters";
import { arrayHelper } from "@helpers/array";
import { useRefinementList } from "react-instantsearch";
import { Client } from "@domain/models/Client";
import { Filter } from "@domain/models/Filters";
import { SelectOption } from "@domain/models/SelectOption";
import DateFilter from "../DateFilter/DateFilter";
import { customSelectStyle } from "@constants/customSelectStyle";
import useUser from "@hooks/useUser";

export type Props = {
  filters: Filter[];
  filterTypes: { headerName: string; field: string }[];
  filtersHighlights: { headerName: string; field: string }[];
  dateField: keyof Pick<Client, "lastReportDate"> | keyof Pick<Client, "updatedAt">;
  onChangeFilters: (filters: Filter[]) => void;
  onClearFilters: () => void;
};

const TableFilter = ({
  filters,
  filterTypes,
  filtersHighlights,
  dateField,
  onChangeFilters,
  onClearFilters,
}: Props) => {
  const { operatorsNames } = useUser();
  const [modalMoreFilters, setModalMoreFilters] = useState(false);
  const [selectedField, setSelectedField] = useState("");

  const { items } = useRefinementList({
    attribute: selectedField ? selectedField : "name",
    operator: "or",
    sortBy: ["name:asc"],
    limit: 100,
  });

  const filteredItems =
    selectedField === "operatorName" && operatorsNames.length > 0
      ? items.filter((x) => operatorsNames.includes(x.label))
      : items;

  //Date filter
  const [filterCalendar, setFilterCalendar] = useState(false);

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const clearAllFilters = () => {
    onClearFilters();
  };

  const handleMenuClose = () => {
    setSelectedField("");
    setAnchorEl(null);
  };

  const handleMenuOpen = (event, headerName) => {
    if (headerName === "Data") {
      setFilterCalendar(true);
    } else {
      setFilterCalendar(false);
    }

    setSelectedField(event.currentTarget.id);
    setAnchorEl(event.currentTarget);
  };

  const handleChangeFilters = async (newValueArray: SelectOption[], field: string) => {
    const exists = filters.findIndex((x) => x.field === field);

    if (exists != -1) {
      if (newValueArray.length > 0) {
        const newObject = {
          ...filters[exists],
          values: newValueArray,
        };

        const newArray = arrayHelper.replaceItemOfArray(filters, exists, newObject);

        onChangeFilters(newArray);
      } else {
        const newArray = arrayHelper.removeItemOfArray(filters, exists);

        onChangeFilters(newArray);
      }
    } else {
      const newObject: Filter = {
        field: field,
        type: "string",
        values: newValueArray,
      };

      onChangeFilters([...filters, newObject]);
    }
  };

  const handleChangeDateFilter = (calendarValues, field) => {
    const exists = filters.findIndex((x) => x.field === field);

    if (exists != -1) {
      if (calendarValues?.selectedStart || calendarValues?.selectedEnd) {
        const newObject = {
          ...filters[exists],
          values: [],
          dateValue: calendarValues,
        };

        const newArray = arrayHelper.replaceItemOfArray(filters, exists, newObject);

        onChangeFilters(newArray);
      } else {
        const newArray = arrayHelper.removeItemOfArray(filters, exists);

        onChangeFilters(newArray);
      }
    } else {
      const newObject: Filter = {
        field: field,
        type: "date",
        values: [],
        dateValue: calendarValues,
      };

      onChangeFilters([...filters, newObject]);
    }
  };

  const buttonHandle = (label, field) => {
    const exists: Filter = filters.find((x) => x.field === field);

    if (exists) {
      if (exists.type === "string") {
        if (exists.values?.length > 1) {
          return `${exists.values[0].value} +${exists.values.length - 1}`;
        } else {
          return `${exists.values[0].value}`;
        }
      }

      if (exists.type === "date") {
        const selectedStart = exists?.dateValue?.selectedStart;
        const selectedEnd = exists?.dateValue?.selectedEnd;
        if (selectedStart && selectedEnd?.day) {
          return `${selectedStart.day}/${selectedStart.month}/${selectedStart.year} -
                        ${selectedEnd.day}/${selectedEnd.month}/${selectedEnd.year}`;
        }
        if (selectedStart) {
          return `${selectedStart.day}/${selectedStart.month}/${selectedStart.year}`;
        }
      }
    } else {
      return `${label}`;
    }
  };

  const getNumberMoreFilters = () => {
    const filtersFields = arrayHelper.reduceToSimple(filters, "field");

    let count = 0;

    for (const field of filtersFields) {
      const result = filtersHighlights.find((x) => x.field === field);

      if (!result) {
        count++;
      }
    }

    if (count != 0) {
      return `(${count})`;
    } else {
      return "";
    }
  };

  const getOptions = (selectedField: string) => {
    const filter = filters.find((filters) => filters.field === selectedField);

    if (filter) {
      const options = filteredItems.filter((item) =>
        filter?.values.find((x) => x.value !== item.value)
      );
      return options;
    }

    return filteredItems;
  };

  return (
    <Container>
      {filtersHighlights.map((item, index) => (
        <ButtonFilter
          key={index}
          id={item.field}
          onClick={(event) => handleMenuOpen(event, item.headerName)}
        >
          <h4>{buttonHandle(item.headerName, item.field)}</h4>
          <IoMdArrowDropdown
            style={{ cursor: "pointer" }}
            size={18}
            color="#808B9F"
            fill="#808B9F"
          />
        </ButtonFilter>
      ))}

      <MoreFilters onClick={() => setModalMoreFilters(true)}>
        <IoIosAddCircleOutline
          style={{ cursor: "pointer", marginRight: -5 }}
          size={15}
          color="#DE6161"
          fill="#DE6161"
        />
        <h5>Mais </h5>
      </MoreFilters>

      <TextClearFilters onClick={() => clearAllFilters()}>
        <BsEraser style={{ cursor: "pointer", marginRight: -5 }} />
        Limpar {getNumberMoreFilters()}
      </TextClearFilters>

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleMenuClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
        PaperProps={{
          style: {
            width: 400,
            height: 400,
            padding: 10,
            borderRadius: 15,
          },
        }}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        {filterCalendar ? (
          <DateFilter
            filters={filters}
            dateField={dateField}
            onFilterDate={(values) => handleChangeDateFilter(values, dateField)}
            clearDateFilter={() => handleChangeDateFilter(null, dateField)}
            onClose={handleMenuClose}
          />
        ) : (
          <SelectContent>
            <Select
              isClearable={false}
              isSearchable={true}
              defaultValue={
                selectedField && filters && filtersHelper.getDefaultValues(selectedField, filters)
              }
              onChange={(item: SelectOption[]) => handleChangeFilters(item, selectedField)}
              closeMenuOnSelect={false}
              options={getOptions(selectedField)}
              isMulti={true}
              styles={customSelectStyle}
              autoFocus={true}
              menuIsOpen
              defaultMenuIsOpen
            />
            <ConfirmButton onClick={() => handleMenuClose()}>
              <h3>OK</h3>
            </ConfirmButton>
          </SelectContent>
        )}
      </Menu>

      <Modal
        isOpen={modalMoreFilters}
        onRequestClose={() => {
          setModalMoreFilters(false);
        }}
        overlayClassName="modal-overlay"
        className="modal-content"
        contentLabel="Example Modal"
        style={{
          overlay: {
            overflowY: "scroll",
          },
        }}
      >
        <ModalFilterContainer>
          {/* <ModalHeader
            title="Filtros"
            onClose={() => {
              setModalMoreFilters(false);
            }}
          /> */}
          {filterTypes.map((item, index) => {
            if (item.headerName != "Data" && item.headerName != "Ações") {
              return (
                <ModalFilterItem key={`filter-${index}`}>
                  <h4>{item.headerName}</h4>
                  <Select
                    key={`filter-${index}`}
                    isClearable={false}
                    isSearchable={true}
                    defaultValue={
                      item.field && filters && filtersHelper.getDefaultValues(item.field, filters)
                    }
                    closeMenuOnSelect={false}
                    options={getOptions(item.field)}
                    isMulti={true}
                    styles={customSelectStyle}
                    onMenuOpen={() => {
                      setSelectedField(item.field);
                      getOptions(item.field);
                    }}
                    onChange={(newFilters: SelectOption[]) => {
                      handleChangeFilters(newFilters, item.field);
                    }}
                  />
                </ModalFilterItem>
              );
            }
          })}
        </ModalFilterContainer>
      </Modal>
    </Container>
  );
};

export default TableFilter;
